import { render, staticRenderFns } from "./RoomsetDeletionModal.vue?vue&type=template&id=be578e36&scoped=true&"
import script from "./RoomsetDeletionModal.vue?vue&type=script&lang=js&"
export * from "./RoomsetDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be578e36",
  null
  
)

export default component.exports